/**
 * The Firebase app and nothing else.
 *
 * Each service now has its own module (auth.ts, firebase.ts for Firestore,
 * storage.ts, functions.ts) and each starts when something first imports
 * it. They used to start together from one file on import, so the sign-in
 * page, which needs only Auth, downloaded and booted Firestore with its
 * persistent cache, Storage and Functions before it could take a password:
 * about 110 KB gzip and a second of a mid-range phone's CPU, for a screen
 * that reads nothing.
 */
import { initializeApp } from 'firebase/app';

// Web config values are public by design; secrets never live here.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyAofMX972R3IEwyJBlolpv2sZ9FrbHUwSk',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'grant-tracker-f1463.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'grant-tracker-f1463',
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'grant-tracker-f1463.firebasestorage.app',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:134844509252:web:e9663aba55d76593e5a011',
};

export const app = initializeApp(firebaseConfig);

/** Talk to the local emulators rather than production. */
export const useEmulators = import.meta.env.DEV || import.meta.env.VITE_USE_EMULATORS === 'true';

/**
 * scripts/emulators-alt.mjs shifts every emulator port by an offset so two
 * checkouts can run side by side; the screenshot harness (scripts/ui)
 * passes the same offset here.
 */
export const emulatorPortShift = Number(import.meta.env.VITE_EMULATOR_PORT_OFFSET ?? 0) || 0;
